<template>
  <div id="app">
    <loading :isShow="showOrNot" @nextPage="onNextShow"/>
    <page-kv :isShow="showOrNot" @nextPage="onNextShow"/>
    <page-one :isShow="showOrNot" @sendResult="handleResult" @nextPage="onNextShow"/>
    <page-two :fnSrc="imgSrc" :isShow="showOrNot" @nextPage="onNextShow"/>
    <wx-share
      :shareTitle="title"
      :shareDesc="desc"
      :shareImg="thumbImg"
      :shareLink="link"
    />
  </div>
</template>

<script>
import Loading from './pages/loading/loading.vue'
import PageKV from './pages/paegKV/pageKV.vue'
import PageOne from './pages/pageOne/pageOne.vue'
import PageTwo from './pages/paegTwo/pageTwo'
import WxShare from './components/wxShare/wxShare'

export default {
  name: 'App',
  components: {
    Loading,
    'page-kv': PageKV,
    'page-one': PageOne,
    'wx-share': WxShare,
    'page-two': PageTwo
  },
  data() {
    return {
      showOrNot: {
        isLDShow: true,
        isKVShow: false,
        isPOShow: false,
        isPTShow: false
      },
      title: '我不是小学生',
      desc: '我不是小学生，一起来答题',
      thumbImg: 'https://www.jiandoukeji.com/h5/h5-effects/not-a-pupil/common/thumb.jpg',
      link: '',
      imgSrc: ''
    }
  },
  methods: {
    handleResult(para) {
      this.imgSrc = para
    },
    onNextShow(para) {
      Object.keys(this.showOrNot).map((item) => {
        this.showOrNot[item] = false
      })
      this.showOrNot[para] = true
    }
  }
}
</script>

<style>
html, body {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Helvetica Neue", STHeiti, "Microsoft Yahei", Tahoma, Simsun, sans-serif;
}
html {
  font-size: 4.2666vw;
}
#app {
  width: 100%;
  height: 100%;
}
</style>
